import React from 'react';
import i18n from '@nextroll/ar-i18n';

import { NodeHeaderHelpSection } from './NodeHeaderHelpSection/NodeHeaderHelpSection';

interface IProps {
    icon: string;
    serviceTitle: string;
    heading: string;
    contentEl?: React.ReactNode;
    className?: string;
    actionEid?: string;
}

export const NodeHeaderSection = (props: IProps) => {
    let headerText: string;
    if (props.heading) {
        headerText = `${props.serviceTitle}: ${i18n.gettext(props.heading)}`;
    } else {
        headerText = props.serviceTitle;
    }
    return (
        <div data-testid='node-header-section' className={props.className || 'workflow-node-panel-header-container'}>
            <img src={props.icon} alt='icon' height={20} width={20} />
            <h4>
                {
                    headerText
                }
                {props.actionEid && (
                    <NodeHeaderHelpSection
                        serviceTitle={props.serviceTitle}
                        actionEid={props.actionEid}
                    />
                ) }
            </h4>
            {
                props.contentEl
            }
        </div>
    );
};
